<template>
  <g class="axis axis--x"
    :transform="`translate(0, ${height - margin.bottom})`"
    fill="none"
    font-size="10"
    text-anchor="middle"
  >
    <g
      v-for="(tick, index) in xTicks"
      class="tick"
      :key="index"
      :transform="`translate(${tick.sv}, 0)`"
    >
      <line stroke="#eee" stroke-width="2" :y1="-(height - margin.top * 2)" y2="5" :class="[ index === 3 ? 'major' : '' ]" />
      <WrappedText :x="0" :content="tick.f" :y="20" />
    </g>
  </g>
  <g class="axis axis--y"
    :transform="`translate(${margin.left}, 0)`"
    fill="none" font-size="10"
    text-anchor="end"
  >
    <g
      v-for="(tick, index) in yTicks"
      class="tick"
      :key="index"
      :transform="`translate(0, ${tick.sv})`"
    >
      <line stroke="#eee" stroke-width="2" :x1="width - margin.right * 2" x2="-5" style="opacity: 0.5" />
      <WrappedText :x="-12" alignment-baseline="central" text-anchor="end" :content="tick.f" />
    </g>
  </g>
</template>

<script>
import WrappedText from '../atoms/WrappedText.vue'

import { labels } from '../data/texts.js'

export default {
  name: 'PlotAxis',
  props: {
    margin: Object,
    height: Number,
    width: Number,
    xScale: Function,
    yScale: Function,
  },
  components: {
    WrappedText,
  },
  computed: {
    xTicks() {
      if (this.xScale) {
        return this.xScale.ticks(7).map(t => {
          const label = labels.leftright[t] || null;

          return {
            v: t,
            sv: this.xScale(t),
            f: label,
          }
        })
      }
      return null;
    },
    yTicks() {
      if (this.yScale) {
        return this.yScale.ticks(7).map(t => {
          const label = labels.conslib[t] || null;

          return {
            v: t,
            sv: this.yScale(t),
            f: label,
          }
        })
      }
      return null;
    },
  },
  methods: {
  },
}
</script>

<style lang="scss">
.axis {
  font-size: 12px;
  pointer-events: none;

  line:not(.major) {
    opacity: 0.5;
  }
}
</style>